import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const TableViewHeaderCell = (props: Props) => {
    return (
        <S_TableViewHeaderCell className={props.className}>{props.children}</S_TableViewHeaderCell>
    );
};

const S_TableViewHeaderCell = styled.div`
    flex: 1;
    font-weight: bold;
    padding: 0 10px;
`;
